import React, { Fragment } from "react";
import SideBar from "./SideBar";
import Hamburger from "./Hamburger";
import Header from "./Header";

const NavBlog = () => {
    return (
        <Fragment>
            <Hamburger />
            <Header />
            <SideBar />
        </Fragment>
    );
};

export default NavBlog;
